import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import ai_analysis from "../../../images/Emotion_analysis.png";
import discussion from "../../../images/discussion.png";
import ai_thinking from "../../../images/AI_thinking.png";
import ai_idea from "../../../images/ai_idea.png";
import ai_welcome from "../../../images/Welcome_ai.png";
import selling_product from "../../../images/selling_product.png";
import meeting_record  from "../../../images/202401_videoconferenza_03.webm"
import recuritment from "../../../images/recuritment.png";
import therapist from "../../../images/therapist.png";
import fake_ai from "../../../images/ai_emotion_fake.mp4"

export default function StudyOneInstructionPageTwo(){
    return (
        <Container className="study-item">
            <Row>
                <h1 style={{ fontWeight: 'bold'}}>EAI has been widely applied </h1>
                <br /><br /><br />
                <Container style={{width:"90%"}}>

                    <Row className="align-items-start mb-4">
                        <Col xs={9}>
                            <div className="chat-bubble-left">
                            There are now many EAI companies on the market, and I’ve been applied across various domains. 
                            I’ve collected a few advertisements from these companies to showcase potential products.
                            </div>
                        </Col>
                        <Col xs={2} className="text-end">
                            <img
                                src={ai_welcome}
                                alt="FEAI icon"
                                style={{ width: "150px", height: "150px", }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <h1 className="subtitle">Promote products </h1>
                        <p>Sales teams employ EAI to gain insights into how customers feel and respond.</p>
                        <figure style={{ width: "80%", margin: "0 auto" }}>
                            <video 
                                src={meeting_record} 
                                style={{ width: "100%" }} 
                                controls 
                                autoPlay 
                                muted 
                                loop
                            />
                        </figure>
                    </Row>

                    <Row>
                        <h1 className="subtitle">Manage classes</h1>
                        <p>Teachers use Emotion AI to observe students’ attention levels and emotional changes during class.</p>
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                            <div style={{ width: "80%", position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden" }}>
                                <iframe
                                    src="https://www.youtube.com/embed/JMLsHI8aV0g?start=62"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%"
                                    }}
                                    title="Emotion AI in Class"
                                />
                            </div>
                        </div>
                    </Row>
                    <Row>
                        <h1 className="subtitle"> Transform therapy</h1>
                        <p>Therapist monitors their patients' emotional journey</p>
                        <figure style={{ width: "80%", margin: "0 auto" }}>
                        <img src={therapist} alt="" style={{width:"100%"}}/>
                        </figure>
                    </Row> 

                    <Row>
                        <h1 className="subtitle"> Recruitment</h1>
                        <p>Therapist monitors their patients' emotional journey</p>
                        <figure style={{ width: "80%", margin: "0 auto" }}>
                        <img src={recuritment} alt="" style={{width:"100%"}}/>
                        </figure>
                    </Row>

                    <Row>
                        <h1 className="subtitle">Make more human-like AI</h1>
                        <p>People use Emotion AI to analyze users' emotions and enable AI to respond, creating AI-generated videos that appear more human-like.</p>
                        <figure style={{ width: "80%", margin: "0 auto" }}>
                            <video 
                            src={fake_ai} 
                            controls 
                            style={{ width: "100%", height: "auto" }} 
                            >
                            Your browser does not support the video tag.
                            </video>
                        </figure>
                        </Row>
                   
                </Container>
            </Row>
        </Container>
    );
};